import { jsx as _jsx } from "react/jsx-runtime";
import { FocusVisibleManager } from "use-focus-visible";
import { Input } from "../input";
export const DateInput = (props) => (_jsx(FocusVisibleManager, { children: _jsx(Input, Object.assign({}, props)) }));
